var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('de-layout-content',[_c('a-tabs',{model:{value:(_vm.activeKey),callback:function ($$v) {_vm.activeKey=$$v},expression:"activeKey"}},[_c('a-tab-pane',{key:"2",attrs:{"tab":"系统消息"}},[_c('sysMsg')],1)],1)],1)}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }